module.exports = __webpack_public_path__ + "img/poker-d01.d31ebc1e.svg";